/* @flow */

export default {
  root: {
    width: 31,
    height: 30,
  },
};
